import V1CompanyPage from '@/pages/v1/signUp/CompanyPage'
import V2CompanyPage from '@/pages/v2/signUp/CompanyPage'
import { useABTestVariant } from '@app-studio-web/ui/contexts/ABTestContext'
import BaselineCompanyPage from '@app-studio-web/ui/pages/signUp/CompanyPage'

// The sign-up pages navigate to each other by absolute path (/sign-up/password
// and so on), so they cannot sit behind a variant path prefix the way the
// onboarding steps do. Each step is mounted once and picks its own layout from
// the resolved variant instead. The variant comes from context rather than
// getABTestVariantFromContext() because the route element is a stable object:
// React bails out of re-rendering it when a parent re-renders, so only a
// context subscription picks up a variant that resolves after mount.
export default function VariantCompanyPage() {
  const { variant } = useABTestVariant()

  switch (variant) {
    case 'v1':
      return <V1CompanyPage />
    case 'v2':
      return <V2CompanyPage />
    default:
      return <BaselineCompanyPage />
  }
}
